import { useEffect, useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/** Toggle for the user's weekly "Fresh trades near you" digest email preference. */
export default function EmailPrefsToggle() {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/me/email-prefs")
      .then(({ data }) => setEnabled(data?.weekly_digest !== false))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const toggle = async () => {
    const next = !enabled;
    setSaving(true);
    try {
      const { data } = await api.patch("/me/email-prefs", { weekly_digest: next });
      setEnabled(data?.weekly_digest !== false);
      toast.success(next ? "Weekly digest turned on" : "Weekly digest turned off");
    } catch {
      toast.error("Could not update preferences");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="vyrti-card !shadow-none border border-[#E2E2E2] p-4 flex items-center justify-between flex-wrap gap-3" data-testid="email-prefs-panel">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-2xl bg-[#F1F5F9] text-[#0654BA] flex items-center justify-center shrink-0">
          <Mail className="w-4 h-4" />
        </div>
        <div>
          <p className="font-medium text-sm">Fresh trades near you</p>
          <p className="text-xs text-zinc-500 mt-0.5">A weekly email with the 3 best new trades within 25 miles.</p>
        </div>
      </div>
      <button
        onClick={toggle}
        disabled={loading || saving}
        aria-pressed={enabled}
        data-testid="weekly-digest-toggle"
        className={`relative inline-flex items-center h-7 w-12 rounded-full transition-colors disabled:opacity-50 ${
          enabled ? "bg-emerald-500" : "bg-zinc-300"
        }`}
      >
        <span
          className={`inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform ${
            enabled ? "translate-x-6" : "translate-x-1"
          }`}
        />
        {saving && <Loader2 className="absolute -right-6 w-4 h-4 animate-spin text-zinc-400" />}
      </button>
    </div>
  );
}
